import { css } from '@emotion/react';
import { ContainerName } from '../../../constants/styles';
import { cardStyles } from '../../../theme/component-styles';

/** Container width where every Summary layout switches between its narrow and wide grid. */
export const CompanyProfilesContainerBreakpoint = '900px';

/** Width of the Portfolio layout's Digest rail, per design (340px of a 1344px content area). */
export const DigestRailWidth = '340px';

/**
 * The V2 page background, straight from the design's canvas: white at the top falling to lavender.
 * The app shell's `gradients.primary` is close but not it — translucent midstops flatten it and its
 * ends differ. Painted by each V2 layout's `MainWrapper`, so flag-off pages keep the shell's own.
 */
export const summaryPageBackground = 'linear-gradient(to bottom, #ffffff 0%, #dfdffd 100%)';

/**
 * One card slot in a Summary grid. Carries the card chrome, so the border and background enclose the
 * title as well as the content — as the design draws it. A collapsed card is therefore a short
 * bordered box holding just its title row.
 *
 * Deliberately sets no height and no `min-height`: cards are content-height, and any floor here
 * would outlive the collapse. Cards needing a minimum size put it on their body via
 * `childrenContainerStyle`, which `Collapse` hides along with the rest of the content.
 */
export const summaryCardCss = css({
  ...cardStyles,
  // `Panel`'s container declared this, and CompanyDetailsPanel's FieldsWrapper (which Digest also
  // uses) queries `@container fd-panel` to collapse to one column in a narrow card. Drop it and
  // that query silently never matches again.
  containerName: ContainerName.fdPanel,
  containerType: 'inline-size',
  // The design's 12px, rather than cardStyles' 0.5rem/1rem.
  padding: '0.75rem',
  width: '100%',
});

/** Floor for the echarts body. Lives on the card's content rather than the card, so a collapsed
 *  chart card still shrinks to its header. `display: grid` is load-bearing: `MixedChart`'s
 *  `height: 100%` needs a definite parent height, which `min-height` alone does not give it. */
export const summaryChartBodyCss = { display: 'grid', minHeight: '275px' };
